import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://xjdcqqlhniapymicexun.supabase.co'
const SUPABASE_ANON_KEY = 'sb_publishable_68GqHfmdb33dDDpq7nxRiw_ybbsmXr-'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)